import React from 'react';
import './../../../pages/Profissional_Saude/Login_M/style.css';
import { login } from '../../../services/Auth'
import { withRouter } from 'react-router-dom';
import api from '../../../services/api';
import { NavLink } from 'react-router-dom';

//import da API
import { authenticate } from './../../../services/api';
let apiAuthenticate = new authenticate();

class Forms_PSLogin extends React.Component {
    constructor() {
        super();
        this.state = {
            email: "",
            password: "",
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(evt) {
        this.setState({ [evt.target.name]: evt.target.value });
    }
    handleSubmit = evt => {
        evt.preventDefault();

        const professional = {
            email: this.state.email,
            password: this.state.password,
        };

        if (!professional.email || !professional.password) {
            this.setState({ error: "Preencha e-mail e senha para continuar!" });
            console.log('Preencha e-mail e senha para continuar!')
            // } else {api.post(`/authenticate/professional`, professional)
        } else {
            apiAuthenticate.ProfessionalLogin(professional)
                .then(res => {
                    console.log(res);
                    console.log(res.data);
                    console.log(professional);
                    login(res.data.token, res.data._id);
                    localStorage.setItem('professional_id', res.data._id);
                    localStorage.setItem('professional_area', res.data.occupation_area);
                    localStorage.setItem('medical_area', res.data.medical_specialty);
                    this.props.history.push("/tela_ps_painel");
                    window.location.reload(false); // Reload da pagina para automaticamente atualizar a component
                }
                ).catch(error => {
                    alert("E-mail ou Senha incorretos!")
                })
        }
    }
    render() {
        return (
            <form onSubmit={this.handleSubmit} id="forms-PS-Login">
                <input onChange={this.handleChange} name="email" placeholder="E-mail" id="PS-Login" required />
                <input onChange={this.handleChange} name="password" type="password" placeholder="Senha" id="PS-Login" required />
                <button onClick={() => this.handleSubmit} id="PS-Login">Fazer Login</button>
                <NavLink to="/Tela_RedefinirSenha" className="navlink-padrao-style"><p className="btn-fp-main">Esqueci a Senha</p></NavLink>
            </form>
        );
    }
}

Forms_PSLogin = withRouter(Forms_PSLogin);
export default Forms_PSLogin;